import React, { useState } from 'react';
import { Box, Grid, Typography, Button, Container } from '@mui/material';
import { styled } from '@mui/system';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';

// Styled Components
const Section = styled(Box)(({ theme }) => ({
  backgroundColor: '#f8f9fb',
  padding: theme.spacing(10, 2),
  display: 'flex',
  alignItems: 'center',
}));

const ContentWrapper = styled(Container)(() => ({
  perspective: '1000px',
}));

const AnimatedBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'animate' && prop !== 'side',
})(({ animate, side }) => ({
  opacity: 0,
  transform: side === 'left' ? 'rotateY(90deg)' : 'rotateY(-90deg)',
  transition: 'all 1s ease',
  transformOrigin: side,
  ...(animate && {
    opacity: 1,
    transform: 'rotateY(0deg)',
  }),
}));

const Img = styled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '500px',
  height: 'auto',
  borderRadius: '16px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
  display: 'block',
  margin: '0 auto',
}));

export default function AboutUs() {
  const { t, i18n } = useTranslation();
  const { ref: imageRef, inView: imageInView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const { ref: textRef, inView: textInView } = useInView({ triggerOnce: true, threshold: 0.3 });



  const pdfUrl = 'LUL.pdf';
  const openPdf = () => {
    window.open(pdfUrl, '_blank');
  };

  const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';
  const textAlign = direction === 'rtl' ? 'right' : 'left';

  return (
    <Section dir={direction}>
      <ContentWrapper maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Text Section */}
          <Grid item xs={12} md={6}>
            <AnimatedBox
              ref={textRef}
              animate={textInView}
              side="right"
              sx={{ textAlign }}
            >
              <Typography
                variant="h3"
                fontWeight={700}
                gutterBottom
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  color: '#0d1b2a',
                }}
              >
                {t('about.title')}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                paragraph
                sx={{
                  fontSize: { xs: '1rem', md: '1.125rem' },
                  lineHeight: 1.8,
                  mb: 3,
                }}
              >
                {t('about.intro')}
              </Typography>

           
                <>
                  {[t('about.detail1'), t('about.detail2'), t('about.detail3')].map((para, i) => (
                    <Typography
                      key={i}
                      variant="body1"
                      color="text.secondary"
                      paragraph
                      sx={{
                        fontSize: { xs: '1rem', md: '1.125rem' },
                        lineHeight: 1.8,
                        mb: 2,
                      }}
                    >
                      {para}
                    </Typography>
                  ))}
                </>
             

              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 4 }}>
                <Button
                  variant="contained"
                  onClick={openPdf}
                  sx={{
                    backgroundColor: '#0056b3',
                    '&:hover': {
                      backgroundColor: '#003d80',
                    },
                    fontWeight: 'bold',
                    px: 4,
                    py: 1.5,
                    borderRadius: '8px',
                  }}
                >
                  {t('about.readMore')}
                </Button>

              
              </Box>
            </AnimatedBox>
          </Grid>

          {/* Image Section */}
          <Grid item xs={12} md={6}>
            <AnimatedBox ref={imageRef} animate={imageInView} side="left">
              <Img src="image/sd.png" alt={t('about.alt')} />
            </AnimatedBox>
          </Grid>
        </Grid>
      </ContentWrapper>
    </Section>
  );
}
